import React from 'react';
import { NavLink } from 'react-router-dom'; // Import NavLink from react-router-dom
import Logo from '../assets/img/jpis-logo.png';
import './myheader.css'; // Import your CSS file
const MyHeader = () => {
  return (
    <header className='header'>
      <div className="container xl">
        <div className="d-flex aic">
          <div className="logo">
            <NavLink to="/">
              <img src={Logo} alt="Logo" />
            </NavLink>
          </div>
          <nav className='d-flex cc aie flexGrow-1 d-column '>
            {/* Top Buttons */}
            <ul className="top-buttons">
              <li>
                <NavLink to="/online-admission">Online Admission</NavLink>
              </li>
              <li>
                <NavLink to="/latest-news-events">Latest News & Events</NavLink>
              </li>
              <li>
                <NavLink to="/mandatory-public-disclosure">Mandatory Public Disclosure</NavLink>
              </li>
              <li>
                <NavLink to="/login-parents-students">Login Parents/Students</NavLink>
              </li>
            </ul>

            {/* Main Menu */}
            <ul className="main-menu">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/about">About Us</NavLink>
              </li>
              <li className='submenu cc'>
                Infrastructure<span className="icon-down"></span>
                <ul className='submenu-list'>
                  <li><NavLink to="/infrastructure/campus">Campus</NavLink></li>
                  <li><NavLink to="/infrastructure/library">Library</NavLink></li>
                  <li><NavLink to="/infrastructure/labs">Labs</NavLink></li>
                  <li><NavLink to="/infrastructure/school-transport">School Transport</NavLink></li>
                  <li><NavLink to="/infrastructure/audio-visual-room">Audio Visual Room</NavLink></li>
                  <li><NavLink to="/infrastructure/swimming-pool-amphitheatre">Swimming Pool & Amphitheatre</NavLink></li>
                  <li><NavLink to="/infrastructure/medicare">Medicare</NavLink></li>
                </ul>
              </li>
              <li className='submenu cc'>
                Academics<span className="icon-down"></span>
                <ul className='submenu-list '>
                  <li><NavLink to="/academics/curriculum-affiliation">Curriculum & Affiliation</NavLink></li>
                  <li><NavLink to="/academics/scholastic-initiative">Scholastic Initiative</NavLink></li>
                  <li><NavLink to="/academics/enrichment-activities">Enrichment Activities</NavLink></li>
                  <li><NavLink to="/academics/evaluation-assessment">Evaluation & Assessment</NavLink></li>
                  <li><NavLink to="/academics/syllabus-2023-24">Syllabus 2023-24</NavLink></li>
                  <li><NavLink to="/academics/academic-calendar-2023-24">Academic Calendar 2023-24</NavLink></li>
                </ul>
              </li>
              <li>
                <NavLink to="/beyond-classroom">Beyond Classroom</NavLink>
              </li>
              <li className='submenu cc'>
              Admission<span className="icon-down"></span>
              <ul className='submenu-list '>
                  <li><NavLink to="/admission/admission-form">Admission Form</NavLink></li>
                  <li><NavLink to="/admission/online-admission-query">Online Admission Query</NavLink></li>
                  <li><NavLink to="/admission/fee-structure-2023-24">Fee Structure 2023-24</NavLink></li>
                  <li><NavLink to="/admission/book-list-2023-24">Book List 2023-24</NavLink></li>
                  <li><NavLink to="/admission/bus-routes">Bus Routes</NavLink></li>
                  <li><NavLink to="/admission/transfer-certificates">Transfer Certificates</NavLink></li>
                  <li><NavLink to="/admission/sample-tc">Sample TC</NavLink></li>
                  <li><NavLink to="/admission/tc-application">TC Application</NavLink></li>
                </ul>
              </li>
              <li>
                <NavLink to="/boarding">Boarding</NavLink>
              </li>
              <li>
                <NavLink to="/gallery">Gallery</NavLink>
              </li>
              <li className='submenu cc'>
               CBSE<span className="icon-down"></span>
               <ul className='submenu-list '>
                  <li><NavLink to="/cbse/oasis">OASIS</NavLink></li>
                  <li><NavLink to="/cbse/cbse-circulars">CBSE Circulars</NavLink></li>
                </ul>
              </li>
            </ul>
          </nav>
          <div>
            <NavLink to="/contact" className='heabutton'><span className="icon-paper-plane"></span> Contact Us</NavLink>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MyHeader;